module.exports = __webpack_public_path__ + "static/media/webbanner.a6eff0bc.gif";